export const getImageUrl = (imageUrl) => {
    if (
        typeof imageUrl === "string" &&
        imageUrl.startsWith("https://s3.ap-southeast-2.amazonaws.com/")
    ) {
        return imageUrl;
    }
    return null;
};

export const getAssetUrl = (imageUrl) => {
    const url = getImageUrl(imageUrl);
    return url ? url + "?t=" + Date.now() : null; // Applying cache busting to ensures the browser fetches the latest image after update, specially when updating multiple times in a single quote.
};